import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Select } from 'antd';
const uri_catalogs = URI_SETUP+"catalog";
const Option = Select.Option;


class Seasons extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal_new_season_status         : "hide",
            background_filter               : "",
            col_seasons_details             : "hide",
            season_action                   : "new",
            market_lst                        : [],
            market                            : "",
            season_item                     : {
                                                _id             : "",
                                                name            : "",
                                                property_id     : ""
                                            },
            available_years                 : [],
            year                            : 0,
            }
    }

    componentWillMount(){
        this.getCurrentMarkets();
        this.getAvailableYears();
        
    }

    // ----------------------- Handlers -----------------------

    handleSeasonChange = (e) => {
        let season_item = Object.assign({}, this.state.season_item);
        season_item[e.target.name] = e.target.value;
        this.setState({season_item});
    }

    handleSeasonSelector(season) {
        let self = this;
        self.setState({ 
            col_seasons_details : "",
            season_item : season
            });

    }

    handleMarketChange = (e) => {
        let market = Object.assign({}, this.state.market);
        market = e.target.value;
        this.setState({market});
    }

    handleYearChange = (e) => {
        let year = Object.assign({}, this.state.year);
        year = e.target.value;
        this.setState({year});
    }


    // ----------------------- Functions -----------------------

    getAvailableYears(){
        let actual_year = new Date().getFullYear();
        let available_years = [];
        for (let i = (actual_year-4); i < (actual_year+2); i++) {
            available_years.push({
                year            : i,
                status          : ""
            });
        }
        this.setState({ 
            available_years : available_years
        })        
    }

    getCurrentMarkets(){
        axios.get(uri_catalogs+"/market", { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                property_id : this.props.hotel_selected,
                mode        : "imported_free"
            }   
        }).then(request => {
            this.setState({ 
                market_lst        : request.data,
                market            : (request.data[0]!=undefined)?request.data[0]._id.$oid:""
            })
        })

    }


    newSeason() {
        this.getCurrentMarkets();
        this.setState({ 
            modal_new_season_status         :   "",
            background_filter               :   "blur",
            col_seasons_details             :   "hide", 
            season_item                     :   {
                                                _id         : "",
                                                name        : "",
                                                property_id : ""
                                            }
            
            })
    }

    onSubmitNewSeason(e) {
        let self = this;
        e.preventDefault();
        var qs = require("qs");
        let season_item = Object.assign({}, self.state.season_item);
        season_item["property_id"]=self.props.hotel_selected;
        season_item["api_token"]=localStorage.getItem("api_token");
        season_item['market']=self.state.market;

        const seasonItemToSent = qs.stringify(season_item);
        if(self.state.season_action=="new"){
            axios.post(uri_catalogs+"/season", seasonItemToSent)
                    .then(request => { 
                        //console.log(request);
                    })
        }else{
            axios.post(uri_catalogs+"/season/"+self.state.season_item._id.$oid, seasonItemToSent)
            .then(request => { 
                //console.log(request);
            })   

        }
        self.props.setActiveHotel();
        self.setState({ 
            modal_new_season_status      : "hide",
            background_filter              : ""
            })
            
    }

    cancelNewSeason(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            modal_new_season_status    : "hide",
            background_filter           : ""
            })
    }

    // ----------------------- Renders -----------------------

    renderSeasons() {
        let self = this;
        
        return <ul>
                    {   
                        self.props.app.state.lst_seasons.map(function(season, i) {
                            return (<li className="clickable" key={season._id.$oid} onClick={self.handleSeasonSelector.bind(self, season)} >
                                <div className="item-with-details">
                                    {season.name}
                                    <i className="fa fa-angle-right"></i><br />
                                    <span className="item-details"> {season.market.name}</span>    
                                </div>
                            </li>);
                            })
                    }
                </ul>   
    }

    renderSeasonsRanges() {
        return  <ul className="season-range-list">
                    <li className="list-header">
                        <div className="label">
                            {this.state.season_item.name}  
                            <span>{(this.state.season_item.market!=undefined)? this.state.season_item.market.name : "" } </span>  
                            <i className="fa edit fa-edit clickable "></i>
                            <div className="right-select">
                                <select className="form-control" name="year"
                                        onChange={e => this.handleYearChange(e)}
                                        value={ this.state.year }  
                                    >
                                    { Object.keys(this.state.available_years).map((key, index) => {
                                            return( <option key={key} value={key} >
                                                {this.state.available_years[key].year}
                                            </option>);
                                        })
                                    }
                                </select> 
                                <i className="fa edit fa-plus-circle clickable"></i>

                            </div>

                            
                        </div>
                    </li>
                    {   (this.state.season_item.date_ranges!=undefined) &&
                            Object.keys(this.state.season_item.date_ranges).map((key , index) => {
                            return (<li key={index} >
                                            <div className="year">2018</div>
                                            <div className="picker"></div> - 
                                            <div className="picker"></div>
                                        <div className= {(this.state.hotels[key]._id==this.state.hotel._id)?"selected":""} >{this.state.hotels[key].name}<i className="fa fa-edit clickable"></i></div>
                                    </li>);
                            })
                        
                    }
                </ul>   
                
    }
    
    renderMarketSelect() {
        if(this.state.market_lst!=[]){
            return ( <div className="col col-md-12">
                        <select className="form-control" name="market"
                                onChange={e => this.handleMarketChange(e)}
                                value={ this.state.market }  
                            >
                            { Object.keys(this.state.market_lst).map((key_list, index) => {
                                    return( <option key={index} value={this.state.market_lst[key_list]._id.$oid} >
                                        {this.state.market_lst[key_list].name}
                                    </option>);
                                })
                            }
                        </select>   
                    </div>
                    );
        }  
    } 

    renderNewSeason() {
        return <div className="box regular col-md-4 ">
                    <h3>
                        { (this.state.season_action=='new')? 'DEFINE NEW SEASON ': 'EDIT SEASON ' }
                        <i className="fa fa-times-circle" onClick={this.cancelNewSeason.bind(this)} ></i> 
                    </h3>
                    <div className="form-in-box">
                        <form id="schema_form" onSubmit={this.onSubmitNewSeason.bind(this)}> 
                            <div className="col col-md-12">
                                <label htmlFor="name">{this.state.season_action=="new"? "Add new season": "Edit season" }</label>
                                <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.season_item.name==null)? "": this.state.season_item.name} required onChange={e => this.handleSeasonChange(e)}  />          
                            </div>
                            {this.renderMarketSelect()}
                            <div className="form-row modal-buttons">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelNewSeason.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="submit" className="blue" >DEFINE</button> 
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

    }


    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                        <form id="catalog_item_form"  >
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Season</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>It exists some dates that are too relevant to pass up, </strong> <br/> setup those dates and prepare to be amazed, MagnumLeap now will be capable to compare the given dates. </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-4">
                            <h3>SEASONS</h3>
                            <div className="list-in-box">
                                {this.renderSeasons()}
                                <button className="blue" onClick={this.newSeason.bind(this)}>NEW</button>
                            </div>
                        </div>

                        <div className={this.state.col_seasons_details+" box regular col-md-7"} >
                            <h3>DATE RANGES BY YEAR</h3>
                            <div className="list-in-box">   
                               { this.renderSeasonsRanges()} 
                            </div>
                        </div>
                    
                    </div>


                </div>

                <div className={"modal " + this.state.modal_new_season_status}> 
                    {this.renderNewSeason()}
                </div>


            </section>
        )
    }

}

export default Seasons


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Seasons.js